export default "__VITE_ASSET__5c3ef022__"